import script from "./RefiUnderpaymentConsent.vue?vue&type=script&setup=true&lang=ts"
export * from "./RefiUnderpaymentConsent.vue?vue&type=script&setup=true&lang=ts"

import "./RefiUnderpaymentConsent.vue?vue&type=style&index=0&id=3ddfd26a&lang=css"

const __exports__ = script;

export default __exports__